// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"
import axios from 'axios';

// need: transition-name
// dynamic:
// prev-transition-name
// next-transition-name

const TRANSITION_MAPPING = {
  'signup': 'Dividend::Common::SignupPaymentFormComponent',
  'forget-password': 'Dividend::Common::ForgetPasswordSubmittedComponent',
  'update-password': 'Dividend::Common::UpdatePasswordSubmittedComponent',
  'update-password-expired': 'Dividend::Common::UpdatePasswordExpiredComponent',
}

class Transition extends Controller {
  connect() {
    this.transitionName = this.element.dataset['transitionName'];
    this.slug = this.element.dataset['slug'];
    if (this.element.dataset['prevTransitionName']) {
      this.previousElement = document.querySelector(`[data-transition-name="${this.element.dataset['prevTransitionName']}"]`)
      this.previousElement.dataset['nextTransitionName'] = this.transitionName;
    }
  }

  htmlToElements(html) {
    const template = document.createElement('template');
    template.innerHTML = html;
    return template.content.childNodes;
  }

  next() {
    if (this.element.dataset['nextTransitionName']) {
      this.nextElement = document.querySelector(`[data-transition-name="${this.element.dataset['nextTransitionName']}"]`)
    }
    if (this.nextElement) {
      this.transition(this.element, this.nextElement)
    } else {
      const transitionName = this.data.get('name');

      // NB! We don't need to render any components. We tried, but the redirect from
      // there somewhy wouldn't work.
      if (transitionName === 'signup') {
        window.location = "/checkout/?product_token=premium-access";
        return;
      }

      const nextTransitionComponentName = TRANSITION_MAPPING[transitionName];
      const transitionData = this.data.get('data')
      axios.post('/component/html/', {
        type: 'singleton',
        name: nextTransitionComponentName,
        slug: this.slug,
        data: transitionData || '{}'
      }).then(({ data }) => {
        const newNode = this.htmlToElements(data);
        newNode.forEach(domElement => {
          domElement.dataset['prevTransitionName'] = this.transitionName;
          domElement.classList.add('t-hidden');
          // Insert the new dom after the current current
          this.element.parentNode.insertBefore(domElement, this.element.nextSibling);
          this.transition(this.element, domElement)
        })
      })
    }
  }

  prev(e) {
    e.preventDefault()
    this.transition(this.element, this.previousElement)
  }

  transition(e1, e2) {
    e1.classList.add('t-hidden')
    e2.classList.remove('t-hidden')
  }
}

export default Transition;
